<template>
  <div>
    <DjHeader />
    <div>
      <slot />
    </div>
    <DjFooter />
  </div>
</template>

<script lang="ts" setup>
  defineOptions({
    name: 'Default',
  });
</script>
